import type { PostCycleCountsMutation } from "~/gql/mutations/postCycleCounts.generated";
import type { MutationRawResult } from "~/helpers/runMutation";

import mutationOutcome from "~/helpers/mutationOutcome";

export const ENGAGE_COUNT_UNKNOWN = "ENGAGE_COUNT_UNKNOWN";
export const ENGAGE_COUNT_PRE_EFFECT_CODES = [
	"CYCLE_COUNT_QUANTITY_OVER_CAP",
	"ITEM_COMBINED",
	"ENGAGE_LOCATION_NOT_FOUND_BEFORE_EFFECT"
];

const engageCountOutcome = (
	raw: MutationRawResult<PostCycleCountsMutation>,
	attemptId: string,
	itemCount: number,
	locationId: string,
	queuedClientId?: null | string
) => {
	const payload = raw.data?.postCycleCounts;
	// This exact wsapi pre-effect refusal is a protocol match and must not be translated.
	const locationRefusal =
		payload &&
		!payload.success &&
		!payload.cycleCount &&
		payload.itemsPosted === 0 &&
		payload.errors?.length &&
		payload.errors.every(
			(error) =>
				!error.code &&
				error.message === "Location '{locationId}' not found for this tenant.".replace("{locationId}", locationId)
		);
	const evidenced =
		locationRefusal && raw.data
			? {
					...raw,
					data: {
						...raw.data,
						postCycleCounts: {
							...payload,
							errors: payload.errors?.map((error) => ({ ...error, code: "ENGAGE_LOCATION_NOT_FOUND_BEFORE_EFFECT" }))
						}
					}
				}
			: raw;
	return mutationOutcome.classifyRawResult(evidenced, (data) => data.postCycleCounts, {
		attemptId,
		preEffectCodes: ENGAGE_COUNT_PRE_EFFECT_CODES,
		queuedClientId,
		selectIds: (value) =>
			itemCount > 0 && value.success && value.itemsPosted === itemCount ? [value.cycleCount?.id] : [],
		stage: "count"
	});
};

export default engageCountOutcome;
